import { DEFAULT_STATUS, normalizeRunStatus } from "@/runs/status"

import type { RunRowLike } from "@/types/RunRow"

/**
 * Filters run rows by selected statuses (e.g. COMPLETED, FAILED).
 * When no statuses are selected, all rows are returned.
 * Row error_status is compared case-insensitively.
 */
export function applyStatusFilters(
  runRows: RunRowLike[],
  selectedStatuses: string[],
): RunRowLike[] {
  if (selectedStatuses.length === 0) {
    return runRows
  }

  const statusSet = new Set(selectedStatuses.map(normalizeRunStatus))
  return runRows.filter((row) => {
    const rowStatus = normalizeRunStatus(row.error_status ?? DEFAULT_STATUS)
    return statusSet.has(rowStatus)
  })
}
